import { Injectable } from '@angular/core';
import { toString } from 'lodash-es';
import { DataService } from 'src/app/shared/services/data/data.service';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  DataFreshnessCompanyPage,
  DataFreshnessCompanyQuery,
  DataFreshnessOverview,
  DataFreshnessQuery,
  DataFreshnessTablePage,
  DataFreshnessTableQuery,
  DataFreshnessWindow
} from '../models/data-freshness.model';

@Injectable({
  providedIn: 'root'
})
export class AlertsService {

  monitoringApiUrl: string = environment.monitoringApiUrl;
  monitoringPreferenceUrl = `${environment.monitoringApiUrl}/monitoring/preferences`;
  dataFreshnessUrl = `${environment.monitoringApiUrl}/monitoring/data-freshness`;
  private alertsData = new BehaviorSubject<any>(null);

  constructor(private dataService: DataService) { }

  getActiveErrorsByCompanyId(companyId: number) {
    const option = {
      url: `${this.monitoringApiUrl}/monitoring/active-errors`,
      params: {
        companyId: toString(companyId),
      }
    }
    return this.dataService.get(option)
  }

  getDataFreshnessOverview(query: DataFreshnessQuery): Observable<DataFreshnessOverview> {
    return this.dataService.get({
      url: `${this.dataFreshnessUrl}/dashboard/overview`,
      param: this.toParams(query)
    }).pipe(map(response => response.data as DataFreshnessOverview));
  }

  getDataFreshnessTables(query: DataFreshnessTableQuery): Observable<DataFreshnessTablePage> {
    return this.dataService.get({
      url: `${this.dataFreshnessUrl}/dashboard/tables`,
      param: this.toParams(query)
    }).pipe(map(response => response.data as DataFreshnessTablePage));
  }

  getDataFreshnessCompanies(query: DataFreshnessCompanyQuery): Observable<DataFreshnessCompanyPage> {
    return this.dataService.get({
      url: `${this.dataFreshnessUrl}/dashboard/companies`,
      param: this.toParams(query)
    }).pipe(map(response => response.data as DataFreshnessCompanyPage));
  }

  getDataFreshnessWindows(
    summaryId: number,
    query: DataFreshnessQuery,
    afterId: number = 0,
    limit: number = 100
  ): Observable<DataFreshnessWindow[]> {
    return this.dataService.get({
      url: `${this.dataFreshnessUrl}/dashboard/tables/${summaryId}/windows`,
      param: this.toParams({ ...query, afterId, limit })
    }).pipe(map(response => response.data as DataFreshnessWindow[]));
  }

  cacheAlertsData(data: any) {
    this.alertsData.next(data);
  }

  getCachedAlertsData(): Observable<any> {
    return this.alertsData.asObservable();
  }

  getCachedAlertsDataValue(): any {
    return this.alertsData.getValue();
  }

  checkMonitorExists(companyId: number){
    const option = {
      url: `${this.monitoringPreferenceUrl}/monitor-exists/${companyId}`,
    }
    return this.dataService.get(option);
  }

  private toParams(values: object): { [key: string]: string } {
    return Object.keys(values).reduce((params, key) => {
      const value = values[key];
      if (value !== undefined && value !== null && value !== '') {
        params[key] = String(value);
      }
      return params;
    }, {} as { [key: string]: string });
  }
}
